import { Field } from 'Util/Query';

/** @namespace Pwa/Query/AdvoxPopup/Query */
export class AdvoxPopupQuery {
    getPopupQuery() {
        return new Field('popups').addFieldList(this._getFieldList());
    }

    _getFieldList() {
        return [
            'id',
            'title',
            'description',
            'button_cta',
            'button_link',
            'button_color',
            'show_on_desktop',
            'show_on_mobile',
            'time_to_show',
            'when_to_show',
            'type',
            'start_date',
            'end_date',
            'banner',
        ];
    }
}

export default new AdvoxPopupQuery();
